import * as React from 'react';
import CurrentUser from 'auth/CurrentUser';
import ShareRemindModal from 'user/components/ShareRemindModal';
import SettingsStore from 'stores/SettingsStore';
import { promiseSettings } from 'promises/userBootData';

type Props = {
  onRequestHide?: Function;
};

type State = {
  settings: any;
};

class InviteModal extends React.Component<Props, State> {
  static prefetch = [promiseSettings];

  state = {
    settings: SettingsStore.getSettings(),
  };

  closeModal = () => {
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
  };

  render() {
    return (
      <ShareRemindModal
        {...this.props}
        user={CurrentUser.getUser()}
        settings={this.state.settings}
      />
    );
  }
}

export default InviteModal;
